/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_BackInputs */

const en_gc_editor_back = /** @type {(inputs: Gc_Editor_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const zh_gc_editor_back = /** @type {(inputs: Gc_Editor_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Gc_Editor_BackInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_back = /** @type {((inputs?: Gc_Editor_BackInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_BackInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_back(inputs)
	return zh_gc_editor_back(inputs)
});
export { gc_editor_back as "gc.editor.back" }